(function () {
  const SACHET_VARIANT_ID = 52168321433883;
  const SACHET_PRODUCT_ID = 10225599021339;
  const BOTTLE_PRODUCT_ID = 9782451405083;

  let isManaging = false;

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function refreshCartUI() {
    const res = await fetch('/?section_id=main-cart');
    const html = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    if (window.cartManager) {
      window.cartManager.renderItems(doc);
    }
  }

  async function addSachet() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        id: SACHET_VARIANT_ID, 
        quantity: 1
      }),
    });
  }

  async function removeSachet() {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        updates: { [SACHET_VARIANT_ID]: 0 }
      }),
    });
  }

  async function manageSachet() {
    if (isManaging) return;
    isManaging = true;

    try {
      const cart = await getCart();
      const items = cart.items;

      const nonSachetItems = items.filter(item => item.product_id !== SACHET_PRODUCT_ID);
      const hasBottle = items.some(item => item.product_id === BOTTLE_PRODUCT_ID);
      const hasSachet = items.some(item => item.product_id === SACHET_PRODUCT_ID);

      if (nonSachetItems.length === 0) {
        if (hasSachet) {
          await removeSachet();
          await refreshCartUI();
        }
        return;
      }

      if (hasBottle && hasSachet) {
        await removeSachet();
        await refreshCartUI();
      } else if (!hasBottle && !hasSachet) {
        await addSachet();
        await refreshCartUI();
      }
    } finally {
      isManaging = false;
    }
  }

  document.addEventListener('DOMContentLoaded', manageSachet);

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : '';

    if (
      !isManaging &&
      (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))
    ) {
      setTimeout(manageSachet, 100);
    }

    return response;
  };

})();